import { connect } from 'react-redux'
import { compose } from 'redux'
import { createStructuredSelector } from 'reselect'
import { withStyles } from '@material-ui/core'

import { BigCalendarFooterBase } from './BigCalendarFooter'

import { totalSourceMonthSelector, totalPercentSelector } from 'reduxModules/selectors/SourceSelectors'

import { styles } from './styles'

const mapStateToProps = createStructuredSelector({
  totalSourceMonth: totalSourceMonthSelector,
  totalPercent: totalPercentSelector,
})

const enhance = compose(
  connect(mapStateToProps),
  withStyles(styles)
)

export const BigCalendarFooter = enhance(BigCalendarFooterBase)


// WEBPACK FOOTER //
// ./src/components/BigCalendar/components/BigCalendarFooter/index.js